import { Box, Button, Divider, IconButton, Modal, ThemeProvider, Typography } from "@mui/material";
import { darkTheme, style, theme } from "../../../styles/styles";
import { useState } from "react";
import HighlightOffIcon from "@mui/icons-material/HighlightOff";
import { VendorTable } from "./VendorTable";
import AddVendor from "./AddVendor";

export const Vendor = () => {
    const [openModal, setOpenModal] = useState(false);
    const [refreshKey, setRefreshKey] = useState(0);

    const handleOpenModal = () => setOpenModal(true);
    const handleCloseModal = () => setOpenModal(false);

    const handleRefresh = () => {
        setRefreshKey((prev) => prev + 1);
    };

    return (
        <ThemeProvider theme={theme}>
            <Box>
                <Box sx={{ my: 5, display: "flex", justifyContent: "end" }}>
                    <Button
                        onClick={handleOpenModal}
                        variant="contained"
                        sx={{
                            textTransform: "initial",
                            fontFamily: "Gilroy-Bold",
                            height: "50px",
                            px: 7,
                            py: 0.5,
                        }}
                    >
                        Add Vendor
                    </Button>
                </Box>
                <div className="ring-1 ring-[#691e78] rounded-xl ">
                    <ThemeProvider theme={darkTheme}>
                        <Box sx={{ width: "100%" }}>
                            <Box>
                                <VendorTable refreshKey={refreshKey} onRefresh={handleRefresh} />
                            </Box>
                        </Box>
                    </ThemeProvider>
                </div>
                <Modal
                    open={openModal}
                    onClose={handleCloseModal}
                    aria-labelledby="modal-modal-title"
                    aria-describedby="modal-modal-description"
                >
                    <Box sx={style}>
                        <Box align="right" sx={{}}>
                            <IconButton onClick={handleCloseModal}>
                                <HighlightOffIcon />
                            </IconButton>
                        </Box>
                        <Box>
                            <Typography variant="h4" sx={{ textAlign: "center", mb: 2, fontFamily: "Gilroy-Medium" }}>
                                Add Vendor
                            </Typography>
                            <Divider />
                        </Box>
                        <Box p={3} sx={{ overflowY: "scroll", height: "450px" }}>
                            <AddVendor onSuccess={() => {
                                handleRefresh();
                                handleCloseModal();
                            }} />
                        </Box>
                    </Box>
                </Modal>
            </Box >
        </ThemeProvider >
    );
};

export default Vendor;